import { useMemo } from "react";
import { Link } from "react-router-dom";
import { TaskTypes } from "@/config/task-types";
import { getAirdropArgumentValue } from "@/lib/challenges";
import { IAirdropTaskRender } from "./task-renderer.types";
import { Button } from "@/components/ui/button";
import { QuestTaskButton } from "../quest-task-button";
import { TiersTable } from "./components/tiers-table";

export const DefaultTaskRenderer = ({
  task,
  campaign,
  completeTaskMutation,
}: IAirdropTaskRender) => {
  const taskConfig = useMemo(() => {
    const campaignTask = campaign?.tasks?.find((t) => t.id === task.taskGuid);
    if (!campaignTask) return null;
    const parsedTierInfo = JSON.parse(
      getAirdropArgumentValue(campaignTask.arguments, "tierInfo") || "{}"
    );
    const externalLink = JSON.parse(
      getAirdropArgumentValue(campaignTask.arguments, "externalLink") || "{}"
    ) as {
      link: string;
      text: string;
    };
    const tokenInfo = JSON.parse(
      getAirdropArgumentValue(campaignTask.arguments, "tokenInfo") || "{}"
    ) as {
      image: string;
      symbol: string;
    };
    // Parse recurring period
    const recurring = getAirdropArgumentValue(
      campaignTask.arguments,
      "recurring"
    ) as "daily" | "weekly" | undefined;

    // Default tierInfo using campaign metadata
    const defaultTierInfo = {
      type: "token" as const,
      tokenInfo: tokenInfo,
      recurring: recurring,
    };
    return {
      type: campaignTask.type,
      tierInfo:
        Object.keys(parsedTierInfo).length > 0
          ? { ...parsedTierInfo, recurring }
          : defaultTierInfo,
      tiers: JSON.parse(
        getAirdropArgumentValue(campaignTask.arguments, "pointsTiers") || "{}"
      ),
      externalLink,
    };
  }, [campaign, task]);

  const buttonName = useMemo(() => {
    if (task.taskName === TaskTypes.LIKE_POST) {
      return "Like Post";
    } else if (task.taskName === TaskTypes.SHARE_PROGRESS) {
      return "Share Progress";
    } else if (task.taskName === TaskTypes.FOLLOW_TWITTER) {
      return "Follow";
    } else if (task.taskName === TaskTypes.RETWEET) {
      return "Retweet";
    }
    return "Claim";
  }, [task.taskName]);

  return (
    <>
      {/* Display TiersTable if tiers exist */}
      {taskConfig?.tiers && Object.keys(taskConfig.tiers).length > 0 && (
        <TiersTable tiers={taskConfig.tiers} tierInfo={taskConfig.tierInfo} />
      )}

      <div className="flex flex-col gap-4">
        {taskConfig?.externalLink && taskConfig.externalLink?.link && (
          <Link to={taskConfig.externalLink.link} target="_blank">
            <Button variant="secondary" size="lg" className="w-full">
              {taskConfig.externalLink.text}
            </Button>
          </Link>
        )}
        <QuestTaskButton
          buttonText={buttonName}
          taskMutation={completeTaskMutation}
          task={task}
          onClick={() => {
            completeTaskMutation.mutateAsync({
              taskGuid: task.taskGuid,
              taskName: task.taskName,
              campaignId: campaign.id,
              extraArguments: task.extraArguments,
              groupId: campaign.campaignGroup,
            });
          }}
        />
      </div>
    </>
  );
};
